// extracted by mini-css-extract-plugin
export default {"imageWrapper":"qP-z","twoColumnImage":"rP-z"};